import React, { useState } from 'react';
import { Container, Paper, Stack, TextField, Button, Typography } from '@mui/material';
// import SendEmail from '../sendEmail';

const Contact = () => {

    const [ messageDetails, setMessageDetails ] = useState({});

    const handleChange = e => {
        setMessageDetails({...messageDetails, [e.target.name]: e.target.value});
    }

    const handleSubmit = e => {
        e.preventDefault();
        // SendEmail({from: messageDetails.email, subject: "Contact request from: " + messageDetails.name, message: messageDetails.message});
        setMessageDetails({});
    }

    return (
        <Container maxWidth="sm">
            <Typography variant="h4" component="h1" gutterBottom>
                Contact
            </Typography>
            <Paper sx={{ p: 3 }} component="form" onSubmit={handleSubmit}>
                <Stack spacing={2}>
                    <TextField
                        label="Name"
                        name="name"
                        value={messageDetails.name || ''}
                        onChange={handleChange}
                        placeholder="Enter your name"
                        fullWidth
                    />
                    <TextField
                        label="Email address"
                        name="email"
                        type="email"
                        value={messageDetails.email || ''}
                        onChange={handleChange}
                        placeholder="Enter your email"
                        fullWidth
                    />
                    <TextField
                        label="Message"
                        name="message"
                        value={messageDetails.message || ''}
                        onChange={handleChange}
                        placeholder="Your message"
                        multiline
                        rows={3}
                        fullWidth
                    />
                    <Button type="submit" variant="contained" fullWidth>
                        Submit
                    </Button>
                </Stack>
            </Paper>
        </Container>
    );
};

export default Contact;
